import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export const SuperAdminOrAdminOrUserEditAccess = () => {
    const {loggedIn, userRole } = useAuth()
    
    return(
      loggedIn && (userRole==="superadmin" || userRole==='admin' || userRole==='useredit') ? <Outlet/> : <Navigate to="/plans"/>
    )
}